import { Menu, Popover } from "antd";
import styled, { css } from "styled-components";

interface IContentUserInfo {
  size?: boolean | string;
  sizeText?: string;
}

interface IUserProgressContainer {
  topbar?: boolean;
  overflowImage?: boolean;
  zeroMarginTop?: boolean;
  sizeDefault?: boolean;
  mobile?: boolean;
  noPointer?: boolean;
  autoHeight?: boolean;
}

interface IContent {
  mini?: boolean;
  sizeDefault?: boolean;
  autoHeight?: boolean;
  mobile?: boolean;
  topbar?: boolean;
}

export const UserProgressContainer = styled.div<IUserProgressContainer>`
  margin-top: ${({ overflowImage, topbar, zeroMarginTop }) =>
    overflowImage ? "-60px" : topbar || zeroMarginTop ? "0px" : "15px"};
  height: ${({ sizeDefault, mobile }) =>
    sizeDefault ? "63px" : mobile ? "45px" : ""};
  cursor: ${({ noPointer }) => (noPointer ? "auto" : "pointer")};

  p {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.8em;
    text-align: center;
    margin: 10px;
    color: #87d068;
    font-weight: bold;
  }
`;

export const UserProgressContent = styled.div<IContent>`
  z-index: 2;
  position: relative;
  display: flex;
  justify-content: ${({ mini, sizeDefault }) =>
    mini || sizeDefault ? "flex-start" : "center"};
  height: auto;
  width: 100%;
  margin-left: 0px;
  margin: ${({ autoHeight }) => (autoHeight ? "-20px 0 0 8px" : 0)};
  margin-top: 0;

  .progress-bar {
    z-index: 2;
    position: absolute;
  }

  ${({ theme }) =>
    theme.mode === "dark" &&
    css`
      .white-bg {
        background: #242424 !important;
      }

      .ant-progress-circle-trail {
        stroke: #242424 !important;
      }
    `}

  .ant-card-body {
    padding: 10px;
  }

  .ant-progress-circle {
    margin: 0.7px 0px -1px 0px;
    width: ${({ mini, mobile, sizeDefault }) =>
      mini || mobile ? "42px" : sizeDefault ? "62px" : "auto"};
    height: ${({ mini, mobile, sizeDefault }) =>
      mini || mobile ? "42px" : sizeDefault ? "62px" : "auto"};

    .ant-progress-inner {
      width: ${({ mini, mobile, sizeDefault }) =>
        mini || sizeDefault || mobile ? "auto !important" : ""};
      height: ${({ mini, mobile, sizeDefault }) =>
        mini || sizeDefault || mobile ? "auto !important" : ""};
    }
  }

  span {
    display: none;
  }

  img,
  .content-user-info {
    z-index: 1;
    margin: 2.5px;

    width: ${({ mini, mobile, sizeDefault }) =>
      mini || mobile ? "39px" : sizeDefault ? "50px" : "115px"};
    ${({ mini, mobile }) =>
      (mini || mobile) &&
      css`
        min-width: 39px;
        min-height: 39px;
      `};
    height: ${({ mini, mobile, sizeDefault }) =>
      mini || mobile ? "39px" : sizeDefault ? "50px" : "115px"};

    border-radius: 100px;
  }

  .white-bg {
    display: ${({ mini, mobile, sizeDefault }) =>
      mini || sizeDefault || mobile ? "none" : "block"};
    background: #fff;
    width: 120px;
    height: 120px;
    border-radius: 100px;
    position: absolute;
  }
`;

export const PopoverAnt = styled(Popover)`
  margin-top: 0;
`;

export const MenuCustom = styled(Menu)`
  width: 250px;
  height: 100%;
  max-height: 60vh;
  padding: 1rem 0;

  border-right: none;
  border-radius: 8px;

  overflow-y: auto;
  overflow-x: hidden;

  background: ${({ theme }) => theme.colors.modalBackgroundColor};

  .ant-menu-item {
    color: ${({ theme }) => theme.colors.textColor};

    &:active {
      background-color: ${({ theme }) =>
        theme.colors.modalBackgroundColor} !important;
    }

    &:hover {
      &,
      i,
      svg * {
        color: ${({ theme }) => theme.colors.primary};
        stroke: ${({ theme }) => theme.colors.primary};
      }
    }

    .ant-menu-title-content .name {
      color: ${({ theme }) => theme.colors.textColor};
    }
  }

  &::-webkit-scrollbar {
    width: 6px;
    background: #f7f7f7;
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #e5e5e5;
    border-radius: 8px;
  }

  .ant-menu-submenu-title {
    padding: 0 !important;
  }

  .ant-menu-item.ant-menu-item-selected {
    background-color: transparent;
  }

  span.name {
    font-family: "Inter";
    font-style: normal;
    font-weight: 700;
    font-size: 1rem;
    line-height: 1.5rem;
  }

  li {
    div {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      svg,
      i {
        display: grid;
        place-items: center;
        width: 1.5rem;
        height: 1.5rem;
        margin-right: 10px;

        &,
        path {
          color: ${({ theme }) => theme.colors.textColor};
          stroke: ${({ theme }) => theme.colors.textColor};
        }
      }
    }

    span {
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
    }
  }
`;

export const ContentUserInfo = styled.div<IContentUserInfo>`
  display: flex;
  justify-content: center;
  align-items: center;

  .user-progress-initials {
    width: 100%;
    height: 100%;

    div {
      width: inherit;
      height: inherit;
    }

    h1 {
      font-size: 2rem;
    }
  }

  ${(props) =>
    props.sizeText === "small"
      ? css`
          font-size: 12px;
          text-align: center;
        `
      : props.size &&
        css`
          font-size: 36px;
        `}

  span {
    display: inline;
    color: ${({ theme }) => theme.colors.textColor};
    font-weight: 400;
  }
`;
